// extracted by mini-css-extract-plugin
export var quillEditor = "_px-1";
export var variable = "_px-0";